import React from 'react';
import RecommendReviewSaveNavbar from '../RecommendReviewSaveNavbar';
import RecommendReviewSaveInfo from '../RecommendReviewSaveInfo';
import RecommendReviewSaveItemList from '../RecommendReviewSaveItemList';
import './RecommendReviewSaveWrap.scss';

const RecommendReviewSaveWrap = (props) => {
  const {
    form,
    recommendReviewSave,
    setData,
    getRecommendReviewItemList,
    selectRecommendReviewItemList,
    onSubmit,
    onDragEndSelectRecommendReviewItemList,
    getRecommendReviewItemListExcelDownload,
    getSelectedRecommendReviewItemListExcelDownload,
    typeDisabled,
    setRecommendReviewItemListExcelUpload,
  } = props;
  const { recommendReviewInfo, recommendReviewItemList } = recommendReviewSave;

  return (
    <div className="recommend-review-save-wrap">
      {/* 하단 네브바 */}
      <RecommendReviewSaveNavbar onSubmit={onSubmit} />

      {/* 추천 상품 후기 정보 */}
      <RecommendReviewSaveInfo
        form={form}
        setData={setData}
        recommendReviewInfo={recommendReviewInfo}
        typeDisabled={typeDisabled}
      />

      {/* 추천 상품 후기 아이템 리스트*/}
      <RecommendReviewSaveItemList
        recommendReviewItemList={recommendReviewItemList}
        getRecommendReviewItemList={getRecommendReviewItemList}
        selectRecommendReviewItemList={selectRecommendReviewItemList}
        onDragEndSelectRecommendReviewItemList={onDragEndSelectRecommendReviewItemList}
        getRecommendReviewItemListExcelDownload={getRecommendReviewItemListExcelDownload}
        getSelectedRecommendReviewItemListExcelDownload={getSelectedRecommendReviewItemListExcelDownload}
        setRecommendReviewItemListExcelUpload={setRecommendReviewItemListExcelUpload}
      />
    </div>
  );
};

export default RecommendReviewSaveWrap;
